export default function runCookieConsentScript($document, $window, $q, rnClient, rnLocale, $gzAnalytics) {
  'ngInject';

  return $q.all([
    rnLocale.getBcp47Locale(),
    rnClient.getConfig(),
  ]).then(([locale, clientConfig]) => {
    // unwrap document from jqlite wrapper
    let document = $document[0];

    // Set the document lang for OneTrust to reference
    document.documentElement.lang = locale;

    let consentScript = _.get(clientConfig, 'consent.script');
    if (consentScript && _.get(clientConfig, 'consent.show')) {
      $gzAnalytics.eventOpen('cookie consent');

      let scriptElement = document.createElement('script');
      scriptElement.src = consentScript;
      scriptElement.async = true;
      scriptElement.defer = true;
      scriptElement.dataset.documentLanguage = 'true';

      checkForOptanonReady();
      document.head.append(scriptElement);
    }
  });

  function checkForOptanonReady() {
    if (!$window.Optanon || !optanonCSSLoaded()) {
      $window.setTimeout(checkForOptanonReady, 500);
      return;
    }

    handleOptanonReady();
  }

  function optanonCSSLoaded() {
    let ss = $document[0].styleSheets;
    for (let i = 0; i < ss.length; i++) {
      if (ss[i].href && ss[i].href.startsWith('https://optanon.blob.core.windows.net/skins/')) {
        return true;
      }
    }

    return false;
  }

  function handleOptanonReady() {
    $window.Optanon.LoadBanner();
  }

}



// WEBPACK FOOTER //
// ./components/consent/consent.run.js